import { appendDataset } from '@mri-platform/shared/core';
import { JobLogError, JobStatus } from '../models';
import { JobLog } from '../models/job-log';
import { createJobLogErrors } from './job-log-errors';
import { createJobLogs } from './job-logs';
import { testDb } from './test-dataset';

const jobLogs: Partial<JobLog>[] = [
  {
    name: 'Demo-3',
    connection: 'Sample-Connection-3',
    destination: 'Sample-Destination-1',
    status: JobStatus.Failed
  },
  {
    name: 'Demo-4',
    connection: 'Sample-Connection-2',
    destination: 'Sample-Destination-2',
    status: JobStatus.Initiated
  },
  {
    platformId: 1,
    name: 'Demo-5',
    connection: 'Sample-Connection-1',
    destination: 'Sample-Destination-3'
  }
];

const joblogerrors: Partial<JobLogError>[] = [
  {
    jobLogId: 1,
    name: 'Invalid User',
    message:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
    errorType: 'Bad request'
  }
];

export const devDb = appendDataset(testDb, {
  joblogs: {
    additionalData: jobLogs,
    creator: createJobLogs
  },
  joblogerrors: {
    additionalData: joblogerrors,
    creator: createJobLogErrors
  }
});
